import flatten from 'lodash.flatten';
import values from 'lodash.values';

import { MEASURE_BY_SKILL_NAME, PM_MEASURES_BY_APPLICATION } from '../../constants/assessments';

export const hasAlternativeForms = (studentResults, measure, app) => {
    const measureResult = studentResults.find(result => result.measure === measure);
    const measureHasPMForms = PM_MEASURES_BY_APPLICATION[app].includes(measure);

    if (measureResult && measureHasPMForms) return !measureResult.isValid;
    return false;
};

/**
 * Filters out measure results by skill name from student results.
 * @param {Array} studentResults Student results by application.
 * @param {String} skillName Name of the skill to filter by e.g. Letter Names.
 * @return {Array} Array of measure results by skill name.
 */
export const getMeasureResults = (studentResults, skillName) =>
    flatten(values(studentResults)).filter(
        result => result.measure === MEASURE_BY_SKILL_NAME[skillName],
    );
